<template>
    <section class="container">
        <b-loading :is-full-page="true" :active.sync="isLoading" :canCancel="true"></b-loading>
        <b-table :data="gameCompletion" v-if="gameCompletion">
            <template slot-scope="props">
                <b-table-column class="centered-table-content" field="" label="Nb">
                    <div :class="getClassForOverMarkers(props.index, 'num')">{{ props.index + 1}}</div>
                </b-table-column>

                <b-table-column class="centered-table-content" field="activityType" label="Type">
                    <b-tag type="is-info">{{ props.row.question.activityType }}</b-tag>
                </b-table-column>

<!--                <b-table-column class="centered-table-content" field="name" label="Name">
                    <strong>{{ props.row.question.name }}</strong>
                </b-table-column>-->

                <b-table-column class="centered-table-content" field="question" label="Question">
                    {{ props.row.question.question }}
                </b-table-column>

                <b-table-column class="centered-table-content" field="solved" label="Solved by">
                    <div class="solvedBy" v-for="answer in props.row.solved" :key="answer.idTeam">
                        <span class="solvedBy grey-round-white-text">
                            <strong>{{ answer.team.teamName }}</strong> won <span class="numberCircle">{{ answer.score }}&nbsp;points</span> <span class="date">{{ formatDateAndTime(answer.dateLastModified) }}</span>
                        </span>
                    </div>
                </b-table-column>

            </template>
        </b-table>
    </section>
</template>

<script>
    import gameService from '../../services/gamesService'
    import displayHelper from '../../helpers/display-helper'
    const moment = require('moment')

export default {
      name: 'gamecompletion-table',
      props: {
        isBase64ImageRequired: false,
        gameName: ''
      },
      created() {
        this.loadGameCompletion()
      },
      data() {
        return {
          gameId: this.$route.params.id,
          isLoading: true,

          gameCompletion: null,
        }
      },
      methods: {
        loadGameCompletion() {
          const parent = this
          this.isLoading = true
          gameService.getGameCompletion(this.gameId).then((data) => {
            this.gameCompletion = data.gameCompletionAsList
            console.log(this.gameCompletion)
          },
                    (err) => {
                      displayHelper.displayError(parent, 'Error while displaying the gameCompletion: ' + err.message)
                    })
                    .finally(() => {
                      this.isLoading = false
                    })
        },
        getClassForOverMarkers(i, type) {
          if (i > this.maxLinesSelected) {
            return type === 'line' ? 'is-gris' : 'grey-round-white-text'
          } else {
            return type === 'line' ? '' : 'red-round-white-text'
          }
        },
        formatDateAndTime(dateStr) {
          return moment(dateStr).format('DD/MM/YYYY HH:mm').toString()
        },
      },
    }
</script>

<style scoped>
    .centered-table-content {
        vertical-align: middle;
    }

    .cell--profile-picture img {
        max-width: 60px;
        max-height: 60px;
        border-radius: 50%;
    }

    .solvedBy {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .solvedBy span {
        padding-left: 10px;
        padding-right: 10px;
        white-space:nowrap;
        background-color: lightgrey;
        color: #717171;
    }

    .solvedBy span .numberCircle {
        border-radius: 50%;
        padding: 8px;

        background: #fff;
        border: 2px solid #666;
        color: green;
        text-align: center;
    }

    .date {
        margin-left: 10px;
        font-size: 0.8em;
        font-style: italic;
    }

</style>
